import { render, staticRenderFns } from "./NoteList.vue?vue&type=template&id=2839b647&scoped=true&"
import script from "./NoteList.vue?vue&type=script&lang=js&"
export * from "./NoteList.vue?vue&type=script&lang=js&"
import style0 from "./NoteList.vue?vue&type=style&index=0&id=2839b647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2839b647",
  null
  
)

export default component.exports